const $ = require('jquery');
import LookupTable from "../../components/lookupTable/index";
import run from '../../utilities/run';
import {isPresent} from "../../utilities/general";
import render from "../../utilities/render";
import {buildExport,prepareDataToSendController,isEdit,readSpecificObjectFromCurrentData,doAjax,readSpecificKeyFromSearchCriteria,alterSearchCriteriForController,pushFilterSessionCacheState,retriveCriteriaObjectByOperation,isNew,isDeleteView,isOnlyLookupDataUpdate} from "../../utilities/filtersutil";
import {receiptsLookupFieldDropdown} from "./filter/rmaLookupFieldDropdown.js";
const _ = require("underscore");
const targetSelector = "#lookup-receipts";
import {handleCustomDropdownEvents} from "../../utilities/customBootstrapDropdowns";
//import {dataTableComponentData, dataTableNewData} from "../../components/lookupTable/stores/testData.js";
import {actionOptions} from "./filter/actionOptions.js";
import {SUCCESS_MODAL_TIMEOUT} from "../../constants";
let actionList = actionOptions;

let actionCellDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html');
let actionCellDropdownItemTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html');
let actionHeaderDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionHeaderDropdown.html');
let statusPillRenderTemplate = require("../../utilities/filtersutil/html/statusPillsTemplate.html");
const detailLinkHTML = require('../../utilities/filtersutil/html/detailLinkHTML.html');

run(targetSelector, ()=>{
	const entryElement = $(targetSelector);
    const savedViews  =  $(targetSelector).data("saved-views");
    const saveViewURL  =  $(targetSelector).data("save-view-url");
    const deleteViewURL  =  $(targetSelector).data("delete-view-url");
    const portletNamespace =  $(targetSelector).data("portlet-namespace");
    const dataTableComponentData  =  $(targetSelector).data("receipts");
	const filterReceiptsURL  =  $(targetSelector).data("filter-receipts-url");
	const generateLabelURL  =  $(targetSelector).data("generate-label-url");
	const generateFxoReceiptURL  =  $(targetSelector).data("generate-fxo-receipt-url");

    let targetObject = "";
    let totalRecordCount = 0;
    let rmaMobileColumns = "";

    let selectedRows = "";

    function createCustomerName(data, type, row) {
    	let newRender;
	    newRender = render(
	      customerNameTemplate, {
	        firstname: row.rmaFromFirstName,
	        lastname: row.rmaFromLastName
	      }
	    );
	    return newRender;
    }


	function formateDate(createdDate, type, data) {
		if(createdDate != null && createdDate != ""){
		  var date = moment(createdDate).toDate(); // format yyyy-MM-DD
		  var month = date.getMonth() + 1;
		  var today = new Date();
		  today.setHours(0,0,0,0);
		  date.setHours(0,0,0,0);
		  var oneDay = 24*60*60*1000;
		  var diffDays = Math.round(Math.abs((today.getTime() - date.getTime())/(oneDay)));
		  var friendlyText = "";
		  var datePillHTML  = ""
		  if(diffDays < 100){
		  	friendlyText = diffDays.toString() + ' Days Ago';
		  	datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>"+  friendlyText +"</span>"
		  }
		  if(diffDays == 0){
		    friendlyText = 'Today';
		  	datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>"+  friendlyText +"</span>"
		  }else if(diffDays== 1){
		    friendlyText ='Yesterday'
		  	datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>"+  friendlyText +"</span>"
		  }
		  return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear() + datePillHTML;
		}else{
		  return "";
		}
	}

	 let defaultMobileColumns = [
	    	{
	          data: "rmaNumber",
	          title: "RMA Number",
	          class: 'dtc-min-width-sm'
	        },
	        {
	          data: "customerName",
	          title: "Customer",
   			  class: 'dtc-min-width-md'

	        },
	        {
	          data: "itemsReturned",
	          title: "Total Pieces Returned",
	          class: 'dtc-min-width-md'
	        },
	        {
	          data: "returnDate",
	          title: "Created on",
	          class: 'dtc-min-width-md'
	        }
	];

    var receiptsLookup = new LookupTable({
	    // REQUIRED - Set a target element
	    target: $("#lookup-receipts-wrapper"),
	    // REQUIRED - Set which data should be visible for mobile
	    mobileColumns: defaultMobileColumns,
	    tableSearchInput: {
	      // placeholder: 'Custom Search Text'
	      value: (targetObject != "" ? targetObject.value[0] : "")
	    },
	    tableSearchDropdown: {
		  selected: (targetObject == "" ? "" : targetObject.key),
	      columns: receiptsLookupFieldDropdown
	    },
	    newSavedViews: false,
   		bulkSelect: false,
   		savedViews: savedViews,
			dataTable: {

		    data: dataTableComponentData.receipts,
		    columnDefs: [],
		    order: [
							 [4, 'desc']
		    ],
		    columns: [
			    {
		          data: "rmaNumber",
		          render : renderActionWrap,
							title: "Actions",
		          orderable:false,
		          class: 'dtc-action-column'
	            },
		        {
		          data: "rmaNumber",
		          title: "RMA Number",
				  orderable:false,
		          class: 'dtc-min-width-sm'
		        },
		        {
		          data: "customerName",
		          title: "Customer",
				  orderable:false,
	   			  class: 'dtc-min-width-md'

		        },
		        {
		          data: "itemsReturned",
		          title: "Total Pieces Returned",
				  orderable:false,
		          class: 'dtc-min-width-md'

		        },
		        {
		          data: "returnDate",
		          title: "Created on",
							orderable:false,
		          class: 'dtc-min-width-md',
							render: formateDate

		        }
		      ]
	    },
	    paginationData:dataTableComponentData.pagination,
	    filterModal: {
	      // REQUIRED: Sets title of modal
	      title: "Filter Returns",
	      // REQUIRED: Sets unique part of subtitle string.
	      tableType: "rma"
	    },
	    onFetch: function() {
	      let currentData = receiptsLookup.generateData();
	      receiptsLookup.showLoadingOverlay();
				if(isOnlyLookupDataUpdate(currentData)){
					setTimeout(() => {
						doAjax({url: filterReceiptsURL, success: filterSuccessFun, error: errorFun,data:prepareDataToSendController(currentData)});
					},SUCCESS_MODAL_TIMEOUT);
				}

       	}
    });


		function filterSuccessFun(data){
	      let receipts = data.receipts;
	      let page = data.pagination;
	      receiptsLookup.setNewData(receipts);
	      receiptsLookup.setPaginationData(page);
	      receiptsLookup.hideLoadingOverlay();
	  }

		function errorFun(data){
					receiptsLookup.hideLoadingOverlay();
		}

	receiptsLookup.init();

	function renderActionWrap(data, type, row, meta) {
	    let newRender;
	    let statusTarget = actionList["actions"];
	    newRender = render(
	      actionCellDropdownTemplate, {
	        list: renderActionCellList(statusTarget,data,row),
	        index: meta.row
	      }
	    );
	    return newRender;
    };


    function renderActionCellList(list,data,row) {
	    let renderedList;
	    renderedList = _(list).map((item)=>{
	      return render(
	        actionCellDropdownItemTemplate, {
	          icon: item.icon,
	          title: item.title,
	          cls: item.cls,
	          disabled:false
	        }
	      )
   		});
	    return renderedList.join('');
    };


	  $('body').on('click', '.view-label ', function(e) {
		    e.preventDefault();
		    if(shallAllowClick(this)) {
		      let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
		      let parent = $(".dropdown-parent-" + pIndex).parents('tr');
		      let row = $(".data-table-component").dataTable().api().row(parent);
		   	  let url=generateLabelURL+"&rmaIdForShipping="+row.data().recrmaIds+"&rmaReceivingType="+row.data().rmaReceivingType;
			  window.open(url);
		    }
		  });


			$('body').on('click', '.receipt-tacking ', function(e) {
					e.preventDefault();
					if(shallAllowClick(this)) {
						let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
						let parent = $(".dropdown-parent-" + pIndex).parents('tr');
						let row = $(".data-table-component").dataTable().api().row(parent);
						let url=generateFxoReceiptURL+"&rmaId="+row.data().recrmaIds;
						window.open(url);
					}
				});


			function shallAllowClick(currentObj){
		   return  !($(currentObj).hasClass("disabled"));
		  }



	// Allow custom dropdowns to work (based on class 'overflow-dropdown'), check the template for more information...
  	handleCustomDropdownEvents();

  //  $("th.dtc-action-column").html(renderActionHeaderWrap());
});



// WEBPACK FOOTER //
// ./src/pages/fxoReprintLabels/lookup.js